export default __webpack_public_path__ + "static/media/mostra-1.afdd529f.png";